import Header from "components/Header/Header";
import React from "react";

function Tos() {
  return (
    <>
      <Header />
      <div className="homeSection">
        <div className="homeSection-content">
          <div className="wrapper-login-tos">
            <div className="container">
              <h3 className="navv-tos">Terms of Services</h3>
            </div>
            <p> 1. Introduction and Acceptance </p>
            <p>
              By accessing or using International American Massage & Body Professional's platform and services (the
              "Services"), you agree to be bound by these Terms of Service
              ("Terms"). International American Massage & Body Professional provides secure third-party payment
              holding and disbursement services to facilitate transactions
              between buyers and sellers.
            </p>
            <p> 2. Definitions </p>
            <p>
              -"Platform" refers to International American Massage & Body Professional's website, mobile applications,
              and related services <br />-<>"Transaction"</> refers to any
              exchange of funds through our escrow service <br />-<>"Buyer"</>{" "}
              refers to the party sending funds into escrow <br />-<>"Seller"</>{" "}
              refers to the party receiving funds from escrow <br />-
              <>"Escrow Account"</> refers to the secure holding account for
              transaction fund
            </p>

            <p> 3. Service Description </p>
            <p>
              <strong> 3.1 Core Services</strong> <br />
              International American Massage & Body Professional provides: <br />- Secure fund holding services <br />
              - Transaction verification <br />- Fund disbursement upon
              condition fulfillment <br />- Dispute resolution services
            </p>
            <p>
              <strong>3.2 Transaction Process</strong> <br />
              1. Buyer initiates transaction <br />
              2. Seller accepts terms <br />
              3. Buyer deposits funds <br />
              4. Seller fulfills obligations <br />
              5. Buyer approves <br />
              6. Funds are released to seller{" "}
            </p>
            <p> 4. Eligibility and Account Registration </p>
            <p>
              <strong>4.1 Requirements</strong> <br />
              Users must be: <br />
              - At least 18 years old <br />- Legally capable of entering
              binding contracts <br />- Resident in a jurisdiction where our
              services are authorized <br />- Able to provide valid
              identification and documentatio{" "}
            </p>

            <p>
              <strong> 4.2 Account Verification</strong> <br />
              We Require: <br />- Government-issued photo ID <br />- Proof of
              address <br />- Additional documentation for business accounts{" "}
              <br />- Verification of banking information
            </p>
            <p>5. Fees and Charges </p>
            <p>
              <strong>5.1 Fee Structure</strong> <br />
              Escrow fees based on transaction value <br />- Payment processing
              fees <br />- Currency conversion fees if applicable <br />-
              Additional services fees as specified
            </p>
            <p>
              <strong>5.2 Payment Terms</strong> <br />
              - Fees are non-refundable unless required by law <br />- Fees are
              calculated and displayed before transaction commitment <br />-
              Buyer typically responsible for escrow fees unless otherwise
              agreed
            </p>
            <p>6. Transaction Rules and Requirements</p>
            <p>
              <strong>6.1 Prohibited Transactions</strong> <br />
              Services may not be used for: <br />
              - Illegal goods or services <br />
              - Controlled substances <br />
              - Weapons or ammunition <br />
              - Counterfeit items <br />- Any goods or services prohibited by
              law
            </p>
            <p>
              <strong>6.2 Transaction Limitations</strong> <br />
              - Maximum transaction limits based on account level <br />
              - Minimum transaction amounts <br />
              - Geographical restrictions may apply <br />- Currency
              restrictions may apply
            </p>
            <p>7. User Obligations</p>
            <p>
              <strong>7.1 Buyer Obligations</strong> <br />
              - Provide accurate transaction details <br />
              - Deposit required funds promptly <br />
              - Inspect goods/services in agreed timeframe <br />- Provide
              timely approval or dispute notification
            </p>
            <p>
              <strong>7.2 Seller Obligations</strong> <br />
              - Provide accurate item/service descriptions <br />
              - Deliver as specified in transaction terms <br />
              - Maintain proof of delivery <br />- Respond promptly to buyer
              inquiries
            </p>
            <p>8. Fund Holdings and Disbursements</p>
            <p>
              <strong>8.1 Fund Security</strong> <br />
              - Funds held in segregated escrow accounts <br />
              - Protected by industry-standard security measures <br />
              - Insured according to applicable regulations <br />- Subject to
              compliance verification
            </p>
            <p>
              <strong>8.2 Disbursement Rules</strong> <br />
              - Standard holding periods may apply <br />
              - Additional holds for high-risk transactions <br />
              - Verification requirements before release <br />- Automatic
              release timelines when applicable
            </p>
            <p>9. Dispute Resolution</p>
            <p>
              <strong>9.1 Dispute Process</strong> <br />
              1. Party files formal dispute <br />
              2. Evidence submission period <br />
              3. Review by International American Massage & Body Professional <br />
              4. Decision and fund allocation <br />
              5. Appeal process if applicable
            </p>
            <p>
              <strong>9.2 Evidence Requirements</strong> <br />
              - Transaction documentation <br />
              - Communication records <br />
              - Proof of delivery/completion <br />- Additional supporting
              materials
            </p>
            <p>10. Privacy and Security</p>
            <p>
              <strong>10.1 Data Protection</strong> <br />
              We protect: <br />
              - Personal information <br />
              - Transaction details <br />
              - Financial data <br />- Communication records
            </p>
            <p>
              <strong>10.2 Information Sharing</strong> <br />
              Data shared only: <br />
              - As required by law <br />
              - With transaction participants <br />
              - With authorized service providers <br />- As specified in our
              Privacy Policy
            </p>
            <p>11. Liability and Limitations</p>
            <p>
              <strong>11.1 Service Limitations</strong> <br />
              - No guarantee of transaction party performance <br />
              - No verification of item/service quality <br />
              - No liability for user misrepresentation <br />- Force majeure
              exceptions
            </p>
            <p>
              <strong>11.2 Limitation of Liability</strong> <br />
              Our liability limited to: <br />
              - Direct damages only <br />
              - Maximum of fees paid <br />
              - No consequential damages <br />- Exceptions as required by law
            </p>
            <p>12. Account Termination</p>
            <p>
              We may terminate accounts for: <br />
              - Terms violation <br />
              - Fraudulent activity <br />
              - Regulatory requirements <br />
              - Extended inactivity <br />- Risk management purposes
            </p>
            <p>13. Changes and Modifications</p>
            <p>
              <strong>13.1 Terms Changes</strong> <br />
              - 30 days notice for material changes <br />
              - Immediate effect for legal/regulatory changes <br />
              - Continued use constitutes acceptance <br />- Right to reject by
              discontinuing use
            </p>
            <p>
              <strong>13.2 Service Modifications</strong> <br />
              We reserve the right to: <br />
              - Modify features <br />
              - Adjust fee structures <br />
              - Change verification requirements <br />- Update security
              protocols
            </p>
            <p>14. Governing Law and Jurisdiction</p>
            <p>
              - Laws of [Jurisdiction] apply <br />
              - Exclusive jurisdiction for disputes <br />
              - Binding arbitration requirement <br />- Class action waiver
            </p>
            <p>15. Contact Information</p>
            <p>
              For service inquiries: <br />
              - Email: internationalmassagecouncil@gmail.com <br />
              - Phone: (228) 696-4218 
            </p>
            <p>
              For legal notices: <br />
              - Email: internationalmassagecouncil@gmail.com <br />            </p>
            <p>16. Severability and Survival</p>
            <p>
              - Invalid provisions severable <br />
              - Remaining terms survive <br />
              - Fundamental obligations survive termination <br />- Dispute
              terms survive account closure
            </p>
            <p>
              By using International American Massage & Body Professional's Services, you acknowledge reading,
              understanding, and agreeing to these Terms of Service.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Tos;
